export const SET_ORDER = 'order/SET_ORDER';
export const RESET_ORDER = 'order/RESET_ORDER';

export interface SetOrder {
  type: typeof SET_ORDER;
  payload: object;
}


export interface ResetOrder {
  type: typeof RESET_ORDER;
}

// --- Create Union Type
export type ActionsTypes =
  | SetOrder
  | ResetOrder;